import { Injectable } from '@angular/core';

export const ContractorPinKey = 'wr-contractor-pin';
export const ContractorShortCodeKey = 'wr-contractor-shortcode';
export const ContractorLoginAtKey = 'wr-contractor-login-at';
export const QrSessionMaxAgeMs = 12 * 60 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class ContractorCredentialsService {

  getCurrentShortCode(): string | null {
    return sessionStorage.getItem(ContractorShortCodeKey);
  }

  getCurrentPin(): string | null {
    return sessionStorage.getItem(ContractorPinKey);
  }

  setContractorCredentials(shortCode: string, pin: string): void {
    sessionStorage.setItem(ContractorShortCodeKey, shortCode);
    sessionStorage.setItem(ContractorPinKey, pin);
    sessionStorage.setItem(ContractorLoginAtKey, String(Date.now()));
  }

  switchShortCode(shortCode: string): void {
    sessionStorage.setItem(ContractorShortCodeKey, shortCode);
  }

  isSessionExpired(): boolean {
    const loginAt = Number(sessionStorage.getItem(ContractorLoginAtKey));
    if (!Number.isFinite(loginAt) || loginAt <= 0) {
      return true;
    }
    return Date.now() - loginAt > QrSessionMaxAgeMs;
  }

  clearContractorCredentials(): void {
    sessionStorage.removeItem(ContractorPinKey);
    sessionStorage.removeItem(ContractorShortCodeKey);
    sessionStorage.removeItem(ContractorLoginAtKey);
  }
}
